import React from 'react'

const NoData = () => {
    return (
        <div>
            <div className='mt-2'>
                <div className="flex flex-col items-center justify-center w-full max-w-md p-6 mx-auto space-y-4">
                    <div className="w-52 h-52">
                        <img src='/noData.png' alt='' />
                    </div>
                    <h2 className="text-xl font-semibold text-gray-700">No Data Available</h2>
                </div>
            </div>
        </div>
    )
}

export default NoData